var exports = {
  "kL": "x04b3a21e--057eb0--container",
  "AS": "x04b3a21e--057eb0--item",
  "U9": "x04b3a21e--057eb0--count",
  "Qq": "x04b3a21e--057eb0--text",
};

module.exports = exports;
